import { createModel } from "hox";
import React, { useState } from "react";
import { TablePaginationConfig } from "antd/es/table/interface";
import { globalPrompt } from "../../../components2/YhMessage";
import { filterArrId, Optios, transPgToPagination } from "../../../utils/utils"
import { materielTypeService } from "./materielTypeService"
import { IMaterielTypeParams, IMaterielTypeDetail, IMaterielTypeInsert, IMaterielTypeUpdate, IMaterielTypeDisable, IMaterielTypeRemove, IIMaterielTypeSearch } from "./materielTypeTypes"
import { IPgProps, ISearchPage } from "../../../types/FmsTypes";
import { DEFAULT_FIRST_PAGE_NUM, DEFAULT_PAGE_SIZE, defaultMdCmParam } from "../../../utils/constants";
export const dataToTree = (data: IMaterielTypeDetail[]) => {
    const result_tree: any = {}
    for (const item of data) {
        let newObj = { ...item, title: item.name, children: [] }
        result_tree[item.code as string] = newObj
        if (item.pcode as string in result_tree) {
            if (!result_tree[item.pcode as string].children) {
                result_tree[item.pcode as string].children = []
            }
            result_tree[item.pcode as string].children.push(newObj)
        }
    }
    return Object.values(result_tree).filter((obj: any) => !obj.pcode);
}
export const useMaterielTypeModel = createModel(function () {
    const initSearchParams: IMaterielTypeParams = {}

    const [dictData, setDictData] = useState([]);
    const [searchParam, setSearchParam] = useState<IMaterielTypeParams>(initSearchParams)
    const [selectDictRowKey, setSelectDictRowKey] = useState<React.Key[]>([])
    const [selectDictRow, setSelectDictRow] = useState<IMaterielTypeDetail>({});
    const [selectDictPRow, setSelectDictPRow] = useState<IMaterielTypeDetail | undefined>();
    const [addTreeFrom, setAddTreeFrom] = useState<IMaterielTypeInsert>({})
    const [page, setPage] = useState<TablePaginationConfig>({});
    const [optType, setOptType] = useState<number>(1)
    const [root, setRoot] = useState<boolean>(false)
    const upDataSearchParam = (upDataParam: IMaterielTypeParams) => {
        setSearchParam({ ...searchParam, ...upDataParam })
    }
    const resetSearchParam = () => {
        setSearchParam(initSearchParams)
        loadDictData(undefined, initSearchParams)
    }
    const loadDictData = async (pages?: ISearchPage, initParams?: IMaterielTypeParams) => {
        const searchParams = initParams ?? searchParam
        const params = {
            ...searchParams,
            page: {
                pageSize: 10000,
                pageNum: 1
            }
        }
        const { retData } = await materielTypeService.page(params)
        const { records, ...pg } = retData
        setPage(transPgToPagination(pg));
        setDictData(dataToTree(records) as never[])
    }

    const changeTreeForm = (value: any) => {
        console.log(value)
        setSelectDictRow({ ...selectDictRow, ...value })
    }
    const insertTreeForm = (value: any) => {
        console.log(value)
        setAddTreeFrom({ ...addTreeFrom, ...value })

    }
    const updataTreeForm = async () => {
        const params = {
            ...selectDictRow,
            enable: selectDictRow.enable ? 1 : 0,
            sourceApp: "mdm",

        }
        const { retData, retMsg } = await materielTypeService.update(params)
        await globalPrompt("message", { type: "success", text: retMsg });
        await loadDictData()
    }
    const addPeerTreeForm = async () => {
        const params = {
            ...addTreeFrom,
            enable: addTreeFrom.enable ? 1 : 0,
            sourceApp: "mdm",

        }
        const { retData, retMsg } = await materielTypeService.insert(params)
        await globalPrompt("message", { type: "success", text: retMsg });
        await loadDictData()
    }
    const removeTreeForm = async () => {
        const params = {
            ...selectDictRow,
            enable: selectDictRow.enable ? 1 : 0,
            sourceApp: "mdm",

        }
        const { retData, retMsg } = await materielTypeService.remove(params)
        await globalPrompt("message", { type: "success", text: "删除成功" });
        await loadDictData()
    }
    return {
        dictData,
        selectDictRowKey,
        selectDictRow,
        selectDictPRow,
        addTreeFrom,
        page,
        optType,
        root,
        searchParam,
        setDictData,
        setSelectDictRowKey,
        setSelectDictRow,
        setSelectDictPRow,
        setAddTreeFrom,
        setPage,
        setOptType,
        setRoot,
        setSearchParam,
        loadDictData,
        changeTreeForm,
        insertTreeForm,
        updataTreeForm,
        addPeerTreeForm,
        removeTreeForm,
        resetSearchParam,
        upDataSearchParam,

    }
});